import React from 'react';
import { useUserContext } from '../contexts/UserContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
const HeroSection: React.FC = () => {
  const navigate = useNavigate();
  const {
    user, _logout
   } = useUserContext();
  return (
    <div className="relative overflow-hidden">
      <div className="absolute inset-0 z-0 bg-gradient-to-r from-primary-dark to-primary-main opacity-20"></div>
      <div className="relative z-10 mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl md:text-6xl">
            <span className="block">{process.env.REACT_APP_DISPLAYNAME}</span>
            <span className="block text-primary-light">Trade Smarter, Not Harder</span>
          </h1>
         
         
          <p className="mx-auto mt-6 max-w-lg text-xl sm:max-w-3xl">
           Our AI-powered bot takes decisions to make money for you in the volatile crypto market.
           It also shares real-time trading signals and market insights to maximize your crypto investments.
          </p>
          
           <h1 style={{marginTop : '2rem'}} className="text-primary-light text-3xl font-bold tracking-tight">
            <span className="block">“Profit never sleeps — neither does your bot to perform auto trades.”</span>
          </h1>
          {user?.user_uuid ? 
          <div className="mx-auto mt-10 max-w-sm sm:flex sm:max-w-none sm:justify-center">
            <div className="space-y-4 sm:mx-auto sm:inline-grid sm:grid-cols-2 sm:gap-5 sm:space-y-0 items-center justify-center">
              <Link
                to="./dashboard"
                className="flex items-center justify-center rounded-md border border-transparent bg-primary-main px-4 py-3 text-base font-medium text-white shadow-sm hover:bg-primary-dark sm:px-8"
              >
                Go to Dashboard
              </Link>
             <button
                className="flex items-center justify-center bg-red-500 hover:bg-red-600 text-white block w-full text-left px-3 py-2 rounded-md text-base font-medium"
             
                onClick={async () => {
               
                  const result = await _logout();
                  // if(result==1) {
                  //   navigate('/login');
                  // }
                }}
              >
                Logout
              </button>
            </div>
          </div>


          :
          <div className="mx-auto mt-10 max-w-sm sm:flex sm:max-w-none sm:justify-center">
            <div className="space-y-4 sm:mx-auto sm:inline-grid sm:grid-cols-2 sm:gap-5 sm:space-y-0">
              <Link
                to="./register"
                className="flex items-center justify-center rounded-md border border-transparent bg-primary-main px-4 py-3 text-base font-medium text-white shadow-sm hover:bg-primary-dark sm:px-8"
              >
                Get Started
              </Link>
              <Link
                to="./login"
                className="flex items-center justify-center rounded-md border border-primary-light bg-transparent px-4 py-3 text-base font-medium  hover:bg-primary-dark sm:px-8"
              >
                Sign In
              </Link>
            </div>
          </div>  }
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
